import { CSSProperties } from 'react';
import { Card } from 'antd';
import { observer } from 'mobx-react-lite';

import { PageContent } from 'app/ui';

const headerStyle: CSSProperties = {
  marginBottom: '0.5em',
  color: 'rgba(0, 0, 0, 0.85)',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: 1.5,
};

export const HomePage = observer(() => {
  return (
    <PageContent>
      <Card size="small">
        <h1 style={headerStyle}>Добро пожаловать! 👋</h1>
        <div>Выберите пункт из меню слева</div>
      </Card>
    </PageContent>
  );
});
